/* global THREE */
import aframe from "aframe";
import { bindEvent, bindEventPlayPause } from "aframe-event-decorators";
import { closestTarget } from "../systems/missile-system";
import { randomSplits } from "./wave-generator";

let poolEl;

aframe.registerComponent("bomber", {
  schema: {
    speed: { type: "number", default: 0.05 },
    bombSpeed: { type: "number", default: 0.03 },
    distance: { type: "number", default: 0.9 },
    bombs: { type: "int", default: 1 },
    splitSize: { type: "int", default: 0 },
    timeWarpFactor: { type: 'number', default: 1 }
  },
  init() {
    this._startPosition = this.el.object3D.position.clone();

    if (poolEl === undefined) {
      poolEl = document.querySelector("[mipool__bomber]");
    }

    this._distanceFlown = 0;

    this.bombAt = [];
  },
  play() {
    if (!this.started) {
      this._gameState = document.querySelector("[game-state]").components[
        "game-state"
      ];
    }
    this.started = true;
  },
  reset() {
    this._startPosition.copy(this.el.object3D.position);
    this._distanceFlown = 0;
    this._timeWarpFactor = this.data.timeWarpFactor;
    this.el.emit("bomberspawned", this, true);

    this._calculateBombAtDistances();

    // this.el.components.misound.playSound();
  },
  _calculateBombAtDistances() {
    const bombAt = [];
    const nBombs = this.data.bombs;
    const distance = this.data.distance;
    const cellWidth = distance / nBombs;
    const cellCenter = cellWidth / 2;
    const cellJitter = 0.7;

    for (let i = 0; i < nBombs; i++) {
      const center = cellWidth * i + cellCenter;
      const jitter = cellJitter * (Math.random() - 0.5) * cellWidth;
      bombAt.push(center + jitter);
    }

    this.bombAt = bombAt;
  },
  tick: (() => {
    const v1 = new THREE.Vector3();
    return function (t, dt) {
      const forwards = this.el.object3D.getWorldDirection(v1).negate();
      this.el.object3D.position.addScaledVector(
        forwards,
        dt / 1000 * this.data.speed * this._timeWarpFactor
      );
      const prevDistanceFlown = this._distanceFlown;
      this._distanceFlown += dt / 1000 * this.data.speed * this._timeWarpFactor;
      if (this._distanceFlown > this.data.distance) {
        this.returnToPool();
      }

      for (let i = 0; i < this.bombAt.length; i++) {
        const d = this.bombAt[i];
        if (d > prevDistanceFlown && d <= this._distanceFlown) {
          const missiles = this.el.sceneEl.systems["missile"];
          const target = closestTarget(this.el.object3D.position);
          if (!target) {
            break;
          }
          missiles.spawnAndTarget(
            {
              speed: this.data.bombSpeed,
              color: "red",
              isPlayer: false,
              splitAt: randomSplits(this.data.splitSize),
              timeWarpFactor: this._timeWarpFactor
            },
            this.el.object3D.position,
            target
          );
        }
      }
    };
  })(),
  collisionstart: bindEvent(function () {
    this.destroyed();
  }),
  destroyed() {
    this.el.emit("bomberdestroyed", this, true);
    // this.el.components.misound.stopSound();
    this.returnToPool();

    const explosion = poolEl.components.mipool__explosion.requestEntity();
    if (explosion !== undefined) {
      explosion.setAttribute("position", this.el.object3D.position);
      explosion.setAttribute("explosion", {
        growTime: 0.5,
        fadeTime: 0.5,
        size: 0.5
      });
      explosion.components.explosion.reset();
      explosion.play();
    }
  },
  returnToPool() {
    this.el.emit("bomberremoved", this, true);
    const pool = poolEl.components.mipool__bomber;
    pool.returnEntity(this.el);
  },
  gamestatechanged: bindEventPlayPause({ target: "[game-state]" }, function (
    evt
  ) {
    const newState = evt.detail;
    if (newState !== "Playing") {
      this.returnToPool();
    }
  }),
  startTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    this._timeWarpFactor = evt.detail.factor;
  }),
  endTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    this._timeWarpFactor = 1;
  })
});
